export const SYMBOLS_LETTERS = 'LETTERS';
export const SYMBOLS_SIGNS = 'SIGNS';
export const SYMBOLS_NUMBERS = 'NUMBERS';
export const SYMBOLS_SPECIAL = 'SPECIAL';

export const SYMBOLS_SPECIAL_CAPITAL_LETTER = 'CAPITAL_LETTER';
export const SYMBOLS_SPECIAL_NUMBER_START = 'NUMBER_START';
export const SYMBOLS_SPECIAL_SPACE = 'SPACE';
export const SYMBOLS_SPECIAL_UNKNOWN = 'UNKNOWN';
